import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  color: ${({ theme }) => theme.colors.banner.text};
  padding: 18px;
  border-radius: 8px;
  font-size: 16px;

  background-color: ${({ theme }) => theme.colors.body};

  ${breakpoint("tablet")`
    background-color: ${({ theme }) => theme.colors.banner.background};
  `}
`

export const Heading = styled.p`
  color: ${({ theme }) => theme.colors.banner.text};
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 10px 0;
`
